import DataMgr from "@/Fwk/DataMgr";
import {BaseInfo, LoginUserType} from "@/Core/Login/types/user";
import {RewardType} from "@/Core/Reward/RewardInfo";
import {getUserId} from "@/app/utils/auth";

enum LastType {
    user_last_token = 'user_last_token' ,
    user_last_token_time = 'user_last_token_time',
    user_last_userId = 'user_last_userId',
    user_last_account = 'user_last_account',
    user_last_password = 'user_last_password',
    user_last_areaNo = 'user_last_areaNo',
    user_last_zipCode = 'user_last_zipCode',
    user_last_info = 'user_last_info',
    user_last_login_type = 'user_last_login_type',
    user_last_nickName = 'user_last_nickName',
    user_last_reward_type = 'user_last_reward_type',
    user_last_uuidChange = 'user_last_uuidChange',
}

export class LoginUIManager {

    static setLastUserToken(str: string) {
        this.SetData(LastType.user_last_token, str);
    }

    static get getLastUserToken(): string {
        return this.GetData(LastType.user_last_token);
    }

    static setLastUserTokenTime(str: number) {
        this.SetData(LastType.user_last_token_time, str);
    }

    static get getLastUserTokenTime(): number {
        let tokenTime = this.GetData(LastType.user_last_token_time);
        tokenTime = Number(tokenTime);
        if (isNaN(tokenTime)) return 0;
        return tokenTime;
    }

    static setLastUserId(userId: number) {
        this.SetData(LastType.user_last_userId, userId + '');
    }

    static get getLastUserId(): number {
        // return this.GetData(LastType.user_last_userId) || 0;
        return getUserId();
    }

    static setLastUserAccount(mobile: string) {
        this.SetData(LastType.user_last_account, mobile);
    }

    static get getLastUserAccount(): string {
        return this.GetData(LastType.user_last_account) || '';
    }

    static setLastUserPassword(password: string) {
        this.SetData(LastType.user_last_password, password);
    }

    static get getLastUserPassword(): string {
        return this.GetData(LastType.user_last_password) || '';
    }

    static setLastUserAreaCode(areaNo: string) {
        this.SetData(LastType.user_last_areaNo, areaNo);
    }

    static get getLastUserAreaCode(): string {
        return this.GetData(LastType.user_last_areaNo) || '';
    }

    static setLastUserZipCode(zipCode: string) {
        this.SetData(LastType.user_last_zipCode, zipCode);
    }

    static get getLastUserZipCode(): string {
        return this.GetData(LastType.user_last_zipCode) || '';
    }

    static get getLastUserInfo(): BaseInfo {
        let info = this.GetData(LastType.user_last_info);
        if (info){
            return info as BaseInfo;
        }
        return {} as BaseInfo;
    }

    static setLastUserInfo(lastInfo: BaseInfo) {
        this.SetData(LastType.user_last_info, lastInfo);
    }

    static setLastUserLoginType(type: LoginUserType) {
        this.SetData(LastType.user_last_login_type, type);
    }

    static get getLastUserLoginType():LoginUserType {
        let type = this.GetData(LastType.user_last_login_type);
        if (type){
            type = type as LoginUserType;
        }
        else {
            type = LoginUserType.null;
        }
        return type;
    }

    static setLastUserNickName(nickName: string) {
        this.SetData(LastType.user_last_nickName, nickName);
    }

    static get getLastUserNickName():string {
        return this.GetData(LastType.user_last_nickName) || '';
    }


    static setLastUserRewardType(rewardType: RewardType) {
        this.SetData(LastType.user_last_reward_type, rewardType);
    }

    static get getLastUserRewardType():RewardType {
        let type = this.GetData(LastType.user_last_reward_type);
        if (type){
            type = Number(type) as RewardType;
        }
        else {
            type = RewardType.GC;
        }
        return type;
    }

    static setLastUuidChange(str: Boolean) {
        this.SetData(LastType.user_last_uuidChange, str);
    }

    static get getLastUuidChange(): boolean {
        return this.GetData(LastType.user_last_uuidChange);
    }

    static SetData(key: LastType, value: any) {
        DataMgr.setStorage(key, value);
        // if (typeof value)
        // DBMgr.UpdateData(key.toString(), value);
    }

    static GetData(key: LastType) {
        return DataMgr.getStorage(`${key}`);
    }

    static ClearData(key:LastType) {
        DataMgr.clear(key.toString());
    }

    static ClearAll(){
        Object.keys(LastType).forEach(key => {
            DataMgr.clear(key);
        })
        this.ClearData(LastType.user_last_token);
        this.ClearData(LastType.user_last_userId);
        this.ClearData(LastType.user_last_account);
        this.ClearData(LastType.user_last_password);
        this.ClearData(LastType.user_last_areaNo);
        this.ClearData(LastType.user_last_zipCode);
        this.ClearData(LastType.user_last_info);
        this.ClearData(LastType.user_last_nickName);
        this.ClearData(LastType.user_last_uuidChange);
    }

}